<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import uploadFile from "@/views/components/common/form/uploadFile.vue";
import { Input, Row, Col, ButtonGroup, Button } from "view-design";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "banner",
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "标题",
          name: "title",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        // {
        //   label: "技术分类",
        //   name: "category_id",
        //   value: "",
        //   type: "skillcategory_id",
        //   multiple: true,
        //   dropList: [],
        // },
        {
          label: "封面图",
          name: "image",
          value: "",
          type: "image",
          desc: "图片尺寸最低977*505像素",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "是否展示",
          name: "status",
          value: 1,
          type: "switch",
          trueValue: 1,
          falseValue: 0,
        },
        // {
        //   label: "简介",
        //   name: "content",
        //   value: "",
        //   type: "textarea",
        //   maxlength: 500,
        //   rules: [{ type: "string", max: 500, message: "超过最大长度" }],
        // },
        // {
        //   label: "视频",
        //   name: "video",
        //   value: "",
        //   type: "video",
        //   rules: [{ required: false, trigger: "blur" }],
        // },
        // { label: '详情', name: 'detail', value: '', type: 'ueditor' },
        
      ],
      forms: {
        place:"home_banner"
      },
    };
  },
  created() {
  },
  methods: {
    initData() {
      // 加载详情数据
      $form.initData(this, {}, (res) => {
        if (res) {
          this.forms = res;
          this.$forceUpdate();
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      // 数组转JSON
      this.forms.ext_a3 = JSON.stringify(this.Material_ll);
      // console.log(" this.forms", this.forms,this.Material_ll)
      this.$refs.form.validate((valid) => {
        console.log("handleSubmit forms", valid, this.forms);
        if (valid) {
          this.forms.category_id = (this.forms.category_id || []).join(",");
          $form.handleSubmit(this);
        }
      });
    },
  },
};
</script>
